import { render, staticRenderFns } from "./detail-lock.vue?vue&type=template&id=ff4c1736&scoped=true&"
import script from "./detail-lock.vue?vue&type=script&lang=js&"
export * from "./detail-lock.vue?vue&type=script&lang=js&"
import style0 from "./detail-lock.vue?vue&type=style&index=0&id=ff4c1736&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff4c1736",
  null
  
)

export default component.exports